export default __webpack_public_path__ + "static/media/graphql.fc6b9451.png";